import React from 'react';
import { Button, Form, Modal, Message, Radio } from 'semantic-ui-react';
import { SUGGESTED_ADDRESSES_FOUND_TEXT, SUGGESTED_ADDRESSES_HELP_TEXT } from './AddressSuggestionsDisplay.constants';
import { LocationAddressPropType } from '../../../../../../services/proptypes';
import { stringifyAddress } from '../../../../../../utils/address';
import AddressEnteredDisplay from '../AddressEnteredDisplay';
function AddressSuggestionsDisplay(_ref) {
  var open = _ref.open,
    suggestedAddresses = _ref.suggestedAddresses,
    selectedAddress = _ref.selectedAddress,
    manualAddress = _ref.manualAddress,
    onSelect = _ref.onSelect,
    onConfirm = _ref.onConfirm;
  function handleSelectedAddressChange(e, _ref2) {
    var value = _ref2.value;
    onSelect(value);
  }
  return /*#__PURE__*/React.createElement(Modal, {
    open: open
  }, /*#__PURE__*/React.createElement(Modal.Header, null, "Is this what you meant?"), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement("p", null, SUGGESTED_ADDRESSES_FOUND_TEXT), /*#__PURE__*/React.createElement(Message, null, /*#__PURE__*/React.createElement(Form, null, suggestedAddresses.map(function (address) {
    return /*#__PURE__*/React.createElement(Form.Field, {
      key: stringifyAddress(address)
    }, /*#__PURE__*/React.createElement(Radio, {
      label: stringifyAddress(address),
      name: "radioGroup",
      value: address,
      checked: selectedAddress === address,
      onChange: handleSelectedAddressChange
    }));
  }))), /*#__PURE__*/React.createElement(AddressEnteredDisplay, {
    address: manualAddress
  }), /*#__PURE__*/React.createElement("p", null, SUGGESTED_ADDRESSES_HELP_TEXT)), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onConfirm
  }, "Confirm")));
}
export default AddressSuggestionsDisplay;